export const EMAIL_VALIDATION_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PHONE_VALIDATION_PATTERN = /\+7 \(\d*\) \d*-\d*-\d\d/gm
export const SNILS_VALIDATION_PATTERN = /\d*-\d*-\d* \d\d/gm
export const NAME_VALIDATION_PATTERN = /^[A-Za-zА-Яа-яЁё]*$/
export const TELEGRAM_VALIDATION_PATTERN = /^@[A-Za-z\d_]{5,32}$/
